import React from "react";
import LegalPage, { LegalSection } from "../components/LegalPage";

export default function Privacy() {
  return (
    <LegalPage
      title="개인정보 처리방침"
      description="Disparty가 처리하는 개인정보의 항목, 목적, 보관 기간과 이용자 권리를 안내합니다."
      effectiveDate="2026년 8월 3일"
    >
      <LegalSection title="1. 개인정보처리자">
        <p>씨에스소프트(대표 정원우)는 Disparty 서비스의 개인정보처리자입니다. 개인정보 문의 및 권리 행사는 inhyuk0078@gmail.com 또는 010-9174-6988로 접수할 수 있습니다.</p>
      </LegalSection>
      <LegalSection title="2. 처리 항목과 목적">
        <p>로그인·회원 관리: Discord 이용자 ID, 닉네임, 아바타, 이메일, 인증 토큰 및 로그인 기록을 처리하여 회원 식별, 로그인 유지, 부정 이용 방지에 사용합니다.</p>
        <p>서버 서비스: 서버 ID, 서버명, 아이콘, 설명, 초대 링크, 관리자 정보, 명령어 및 갱신 기록을 처리하여 서버 등록·탐색·관리 기능을 제공합니다.</p>
        <p>구매·결제·환불: 주문번호, 상품·가격·적용 서버, 결제키, 결제 상태, 구매 및 환불 기록을 처리하여 주문 이행, 결제 검증, 환불 및 분쟁 대응에 사용합니다. 카드번호 등 결제수단의 핵심 정보는 결제대행사가 직접 처리합니다.</p>
        <p>판매·정산: 개인/사업자 구분, 실명, 크리에이터명, 주소, 휴대전화, 이메일, 사업자명·사업자등록번호, 은행명, 예금주, 계좌번호, 상품·판매·정산 기록을 처리하여 판매자 확인, 상품 판매, 정산, 세무 및 분쟁 대응에 사용합니다.</p>
        <p>서비스 보호: IP 주소, 쿠키, 기기·브라우저 정보, 접속 및 오류 기록을 처리하여 보안, 장애 대응, 통계 및 부정 이용 방지에 사용합니다.</p>
      </LegalSection>
      <LegalSection title="3. 보유 및 이용 기간">
        <p>회원 정보는 회원 탈퇴 또는 처리 목적 달성 시 지체 없이 삭제합니다. 다만 법령에 따라 계약 또는 청약철회 기록과 대금결제·공급 기록은 5년, 소비자 불만·분쟁 처리 기록은 3년, 표시·광고 기록은 6개월 동안 보관합니다.</p>
        <p>판매자 정보와 정산 기록은 판매자 계약 종료 후에도 미정산, 환불, 분쟁, 세무 및 관계 법령상 의무가 끝날 때까지 필요한 범위에서 보관합니다. 부정 이용 기록은 분쟁 대응에 필요한 최소 기간 동안 별도 보관할 수 있습니다.</p>
      </LegalSection>
      <LegalSection title="4. 제3자 제공 및 처리 위탁">
        <p>결제와 취소 처리를 위해 토스페이먼츠에 주문번호, 결제 금액, 상품명 및 결제에 필요한 정보를 제공합니다. 정산지급대행을 사용하는 경우 판매자 본인확인, 계좌 및 지급 정보가 토스페이먼츠에 제공될 수 있으며, 실제 사용 전에 별도 고지와 동의를 받습니다.</p>
        <p>Discord 로그인, 서버 연동 및 봇 기능 제공을 위해 Discord Inc.의 API를 사용합니다. 서비스 운영과 데이터 보관을 위해 호스팅 제공자의 인프라를 이용합니다. 위탁업체가 개인정보를 안전하게 처리하도록 계약과 접근 통제를 적용합니다.</p>
      </LegalSection>
      <LegalSection title="5. 국외 이전">
        <p>Discord 로그인과 서버 API 이용 과정에서 Discord Inc.(미국)에 Discord 계정 및 서버 연동 정보가 네트워크를 통해 전송될 수 있습니다. 이전은 이용자가 Discord 로그인 또는 서버 연동 기능을 사용할 때 발생하며, 서비스 연동 종료 또는 Discord의 정책상 보관 기간까지 처리됩니다.</p>
      </LegalSection>
      <LegalSection title="6. 이용자의 권리">
        <p>이용자는 개인정보 열람, 정정·삭제, 처리정지, 동의 철회를 요청할 수 있습니다. 법정대리인은 만 14세 미만 이용자의 권리를 행사할 수 있습니다. 확인이 필요한 경우 본인 또는 대리인 확인 절차를 요청할 수 있습니다.</p>
      </LegalSection>
      <LegalSection title="7. 파기와 안전성 확보">
        <p>보관 기간이 끝난 전자 파일은 복구하기 어려운 방식으로 삭제하고 출력물은 파쇄합니다. 접근 권한 최소화, 비밀번호·정산 계좌 암호화, 접속 기록 관리, 보안 업데이트와 백업 등 필요한 안전조치를 적용합니다.</p>
      </LegalSection>
      <LegalSection title="8. 쿠키">
        <p>로그인 유지와 서비스 설정을 위해 쿠키를 사용할 수 있습니다. 브라우저 설정에서 쿠키를 거부하거나 삭제할 수 있으나 로그인 등 일부 기능이 제한될 수 있습니다.</p>
      </LegalSection>
      <LegalSection title="9. 방침 변경">
        <p>이 방침의 내용이 변경되면 시행일과 주요 변경 사항을 서비스에 공지합니다. 이용자 권리에 중대한 변경은 충분한 기간을 두고 알립니다.</p>
      </LegalSection>
    </LegalPage>
  );
}
